"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TechseeFormBase = void 0;
var mobx_1 = require("mobx");
var validatorjs_1 = __importDefault(require("validatorjs"));
var TechseeFormBase = (function () {
    function TechseeFormBase() {
        this._fields = {};
        this._isSyncRulesValid = false;
        this.validateOnChange = false;
        this.setupValidationReaction();
    }
    Object.defineProperty(TechseeFormBase.prototype, "fields", {
        get: function () {
            return this._fields;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TechseeFormBase.prototype, "isValid", {
        get: function () {
            return this._isSyncRulesValid;
        },
        enumerable: false,
        configurable: true
    });
    TechseeFormBase.prototype.addField = function (name, model) {
        this._fields[name] = model;
        this.setupValidationReaction();
    };
    TechseeFormBase.prototype.removeFields = function (fieldNames) {
        var _this = this;
        if (fieldNames) {
            this._fields = Object.keys(this._fields)
                .filter(function (key) { return !fieldNames.includes(key); })
                .reduce(function (obj, key) {
                var _a;
                return (__assign(__assign({}, obj), (_a = {}, _a[key] = _this._fields[key], _a)));
            }, {});
        }
        else {
            this._fields = {};
        }
    };
    TechseeFormBase.prototype.hasField = function (name) {
        return this._fields.hasOwnProperty(name);
    };
    TechseeFormBase.prototype.validateForm = function () {
        var validationResult = this.createValidator();
        var isValid = validationResult.passes();
        var errors = validationResult.errors.all();
        this.setFormFieldsErrors(errors);
        this._isSyncRulesValid = isValid === true;
        return Promise.resolve(this.isValid);
    };
    TechseeFormBase.prototype.displayFieldsErrors = function () {
        var _this = this;
        var result = {};
        Object.keys(this._fields).forEach(function (key) {
            _this.displayFieldErrors(_this._fields[key]);
        });
        return result;
    };
    TechseeFormBase.prototype.setFieldError = function (fieldName, errors, immediateDisplay) {
        if (immediateDisplay === void 0) { immediateDisplay = true; }
        if (!this._fields[fieldName]) {
            throw new Error("Field ".concat(fieldName, " is not exists in form."));
        }
        this._fields[fieldName].setFieldError(errors);
        if (immediateDisplay) {
            this.displayFieldErrors(this._fields[fieldName]);
        }
    };
    TechseeFormBase.prototype.resetFormFields = function () {
        var _this = this;
        Object.keys(this._fields).forEach(function (key) {
            _this._fields[key].resetField();
        });
    };
    TechseeFormBase.prototype.setupValidationReaction = function () {
        this._modelChangeDisposer && this._modelChangeDisposer();
        this._modelChangeDisposer = (0, mobx_1.reaction)(this.extractValidationTriggers.bind(this), this.validateForm.bind(this));
    };
    TechseeFormBase.prototype.createValidator = function () {
        var data = this.extractFieldsData();
        var rules = this.extractFieldsRules();
        return new validatorjs_1.default(data, rules.rules, rules.messages);
    };
    TechseeFormBase.prototype.displayFieldErrors = function (field) {
        if (this.validateOnChange) {
            field.setWasChanged(true);
        }
        else {
            field.setWasBlured(true);
        }
    };
    TechseeFormBase.prototype.setFormFieldsErrors = function (errors) {
        var _this = this;
        Object.keys(this._fields).forEach(function (key) {
            _this._fields[key].setFieldError(errors[key] || []);
        });
    };
    TechseeFormBase.prototype.extractFieldsData = function () {
        var _this = this;
        var result = {};
        Object.keys(this.fields).forEach(function (key) {
            result[key] = _this.fields[key].value;
        });
        return result;
    };
    TechseeFormBase.prototype.extractFieldsRules = function () {
        var _this = this;
        var rules = {};
        var messages = {};
        Object.keys(this.fields).forEach(function (key) {
            var fieldRules = _this.fields[key].disabled ? [] : _this.fields[key].rules;
            var combinedRules = fieldRules.map(function (r) { return r.rule; }).join('|');
            if (combinedRules) {
                rules[key] = fieldRules.map(function (r) { return r.rule; }).join('|');
            }
            fieldRules.forEach(function (r) {
                if (r.message) {
                    messages["".concat(r.rule.split(':')[0], ".").concat(key)] = r.message;
                }
            });
        });
        return { rules: rules, messages: messages };
    };
    TechseeFormBase.prototype.extractValidationTriggers = function () {
        var _this = this;
        var result = {};
        Object.keys(this.fields).forEach(function (key) {
            result[key + '_blur'] = _this.fields[key].wasBlured;
            result[key + '_change'] = _this.fields[key].wasChanged;
            result[key] = _this.fields[key].value;
        });
        return result;
    };
    TechseeFormBase.prototype.snapshotFormValues = function () {
        var _this = this;
        Object.keys(this.fields).forEach(function (key) {
            _this.fields[key].snapshotCurrentValue();
        });
    };
    TechseeFormBase.prototype.revertToLastSnapshot = function () {
        var _this = this;
        Object.keys(this.fields).forEach(function (key) {
            _this.fields[key].revertValueToLastSnapshot();
        });
    };
    __decorate([
        mobx_1.observable
    ], TechseeFormBase.prototype, "_fields", void 0);
    __decorate([
        mobx_1.observable
    ], TechseeFormBase.prototype, "_isSyncRulesValid", void 0);
    __decorate([
        mobx_1.observable
    ], TechseeFormBase.prototype, "validateOnChange", void 0);
    __decorate([
        mobx_1.computed
    ], TechseeFormBase.prototype, "fields", null);
    __decorate([
        mobx_1.computed
    ], TechseeFormBase.prototype, "isValid", null);
    return TechseeFormBase;
}());
exports.TechseeFormBase = TechseeFormBase;
